/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthInitSpaceRouteRouteImport } from './routes/_auth-init-space/route'
import { Route as AuthInitSpaceIndexRouteImport } from './routes/_auth-init-space/index'
import { Route as AuthInitSpaceAuthorizedRouteRouteImport } from './routes/_auth-init-space/_authorized/route'
import { Route as AuthInitSpaceAuthorizedStoriesIndexRouteImport } from './routes/_auth-init-space/_authorized/stories/index'
import { Route as AuthInitSpaceAuthorizedLegalIndexRouteImport } from './routes/_auth-init-space/_authorized/legal/index'
import { Route as AuthInitSpaceAuthorizedStoriesArticleIdRouteImport } from './routes/_auth-init-space/_authorized/stories/$articleId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInitSpaceRouteRoute = AuthInitSpaceRouteRouteImport.update({
  id: '/_auth-init-space',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInitSpaceIndexRoute = AuthInitSpaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthInitSpaceRouteRoute,
} as any)
const AuthInitSpaceAuthorizedRouteRoute =
  AuthInitSpaceAuthorizedRouteRouteImport.update({
    id: '/_authorized',
    getParentRoute: () => AuthInitSpaceRouteRoute,
  } as any)
const AuthInitSpaceAuthorizedStoriesIndexRoute =
  AuthInitSpaceAuthorizedStoriesIndexRouteImport.update({
    id: '/stories/',
    path: '/stories/',
    getParentRoute: () => AuthInitSpaceAuthorizedRouteRoute,
  } as any)
const AuthInitSpaceAuthorizedLegalIndexRoute =
  AuthInitSpaceAuthorizedLegalIndexRouteImport.update({
    id: '/legal/',
    path: '/legal/',
    getParentRoute: () => AuthInitSpaceAuthorizedRouteRoute,
  } as any)
const AuthInitSpaceAuthorizedStoriesArticleIdRoute =
  AuthInitSpaceAuthorizedStoriesArticleIdRouteImport.update({
    id: '/stories/$articleId',
    path: '/stories/$articleId',
    getParentRoute: () => AuthInitSpaceAuthorizedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthInitSpaceIndexRoute
  '/login': typeof LoginRoute
  '/stories/$articleId': typeof AuthInitSpaceAuthorizedStoriesArticleIdRoute
  '/legal/': typeof AuthInitSpaceAuthorizedLegalIndexRoute
  '/stories/': typeof AuthInitSpaceAuthorizedStoriesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthInitSpaceIndexRoute
  '/stories/$articleId': typeof AuthInitSpaceAuthorizedStoriesArticleIdRoute
  '/legal': typeof AuthInitSpaceAuthorizedLegalIndexRoute
  '/stories': typeof AuthInitSpaceAuthorizedStoriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth-init-space': typeof AuthInitSpaceRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth-init-space/_authorized': typeof AuthInitSpaceAuthorizedRouteRouteWithChildren
  '/_auth-init-space/': typeof AuthInitSpaceIndexRoute
  '/_auth-init-space/_authorized/stories/$articleId': typeof AuthInitSpaceAuthorizedStoriesArticleIdRoute
  '/_auth-init-space/_authorized/legal/': typeof AuthInitSpaceAuthorizedLegalIndexRoute
  '/_auth-init-space/_authorized/stories/': typeof AuthInitSpaceAuthorizedStoriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/stories/$articleId' | '/legal/' | '/stories/'
  fileRoutesByTo: FileRoutesByTo
  to: '/login' | '/' | '/stories/$articleId' | '/legal' | '/stories'
  id:
    | '__root__'
    | '/_auth-init-space'
    | '/login'
    | '/_auth-init-space/_authorized'
    | '/_auth-init-space/'
    | '/_auth-init-space/_authorized/stories/$articleId'
    | '/_auth-init-space/_authorized/legal/'
    | '/_auth-init-space/_authorized/stories/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthInitSpaceRouteRoute: typeof AuthInitSpaceRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-init-space': {
      id: '/_auth-init-space'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthInitSpaceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-init-space/': {
      id: '/_auth-init-space/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthInitSpaceIndexRouteImport
      parentRoute: typeof AuthInitSpaceRouteRoute
    }
    '/_auth-init-space/_authorized': {
      id: '/_auth-init-space/_authorized'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthInitSpaceAuthorizedRouteRouteImport
      parentRoute: typeof AuthInitSpaceRouteRoute
    }
    '/_auth-init-space/_authorized/stories/': {
      id: '/_auth-init-space/_authorized/stories/'
      path: '/stories'
      fullPath: '/stories/'
      preLoaderRoute: typeof AuthInitSpaceAuthorizedStoriesIndexRouteImport
      parentRoute: typeof AuthInitSpaceAuthorizedRouteRoute
    }
    '/_auth-init-space/_authorized/legal/': {
      id: '/_auth-init-space/_authorized/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof AuthInitSpaceAuthorizedLegalIndexRouteImport
      parentRoute: typeof AuthInitSpaceAuthorizedRouteRoute
    }
    '/_auth-init-space/_authorized/stories/$articleId': {
      id: '/_auth-init-space/_authorized/stories/$articleId'
      path: '/stories/$articleId'
      fullPath: '/stories/$articleId'
      preLoaderRoute: typeof AuthInitSpaceAuthorizedStoriesArticleIdRouteImport
      parentRoute: typeof AuthInitSpaceAuthorizedRouteRoute
    }
  }
}

interface AuthInitSpaceAuthorizedRouteRouteChildren {
  AuthInitSpaceAuthorizedStoriesArticleIdRoute: typeof AuthInitSpaceAuthorizedStoriesArticleIdRoute
  AuthInitSpaceAuthorizedLegalIndexRoute: typeof AuthInitSpaceAuthorizedLegalIndexRoute
  AuthInitSpaceAuthorizedStoriesIndexRoute: typeof AuthInitSpaceAuthorizedStoriesIndexRoute
}

const AuthInitSpaceAuthorizedRouteRouteChildren: AuthInitSpaceAuthorizedRouteRouteChildren =
  {
    AuthInitSpaceAuthorizedStoriesArticleIdRoute:
      AuthInitSpaceAuthorizedStoriesArticleIdRoute,
    AuthInitSpaceAuthorizedLegalIndexRoute:
      AuthInitSpaceAuthorizedLegalIndexRoute,
    AuthInitSpaceAuthorizedStoriesIndexRoute:
      AuthInitSpaceAuthorizedStoriesIndexRoute,
  }

const AuthInitSpaceAuthorizedRouteRouteWithChildren =
  AuthInitSpaceAuthorizedRouteRoute._addFileChildren(
    AuthInitSpaceAuthorizedRouteRouteChildren,
  )

interface AuthInitSpaceRouteRouteChildren {
  AuthInitSpaceAuthorizedRouteRoute: typeof AuthInitSpaceAuthorizedRouteRouteWithChildren
  AuthInitSpaceIndexRoute: typeof AuthInitSpaceIndexRoute
}

const AuthInitSpaceRouteRouteChildren: AuthInitSpaceRouteRouteChildren = {
  AuthInitSpaceAuthorizedRouteRoute:
    AuthInitSpaceAuthorizedRouteRouteWithChildren,
  AuthInitSpaceIndexRoute: AuthInitSpaceIndexRoute,
}

const AuthInitSpaceRouteRouteWithChildren =
  AuthInitSpaceRouteRoute._addFileChildren(AuthInitSpaceRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthInitSpaceRouteRoute: AuthInitSpaceRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
